export default "https://assets.egbcdn.net/assets/packs/_/sounds/poker/check-0916cfde9f38e224d541cfe250d6ce15.mp3";